<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div
        v-if="showFloatingWatcher"
        class="watcher-floating-tab"
        :style="watcherFloatingStyle"
        @click="onWatcherTabClick"
        @mousedown.prevent="startWatcherDrag"
        @touchstart.prevent="startWatcherDrag"
      >
        <div class="watcher-fallback-gif">
          <span class="watcher-detective">🕵️</span>
          <span class="watcher-lens">🔍</span>
        </div>
        <div class="watcher-floating-text">
          <strong>Watcher ativo</strong>
          <small v-if="watcherStatusSummary.has_pending_events">NF cancelada detectada</small>
          <small v-else>Carga sob monitoramento</small>
        </div>
        <span v-if="watcherStatusSummary.has_pending_events" class="watcher-pending-pill">
          {{ watcherStatusSummary.open_events_count }}
        </span>
      </div>

      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Expedição</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                :class="{ visible: getSubMenuShowHideFw() }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                        @click="onAgrupa()"
                        v-b-tooltip
                        title="Agrupar Cargas"
                    ><i class="fa fa-object-group"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('expedicao.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('expedicao.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'doc_fiscal'">
                  </vuetable-filterbar>
                  <spinner
                    v-if="loadingDataExpedir"
                    text-fg-color="#ffffff"
                    message="Carregando..."
                  ></spinner>
                  <spinner
                    v-if="loading"
                    text-fg-color="#000000"
                    message="Carregando..."
                  ></spinner>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                      :key="tableKey"
                      ref="vuetable"
                      :load-on-start="false"
                      :fields="fields"
                      :css="css"
                      :append-params="moreParams"
                      :api-url="expedicaoApiUrl"
                      track-by="cargaId"
                      pagination-path="meta"
                      detail-row-component="expedicao-detalhes"
                      no-data-template="Nenhum dado encontrado. Escolha um filtro indicado ou atualize a página."
                      @vuetable:load-error="onError"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loaded="onLoaded"
                      class="table-responsive-sm"
                  >
                    <template slot="transportadora" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.pessoa !== null &&
                          props.rowData.pessoa.pessoaJuridica !== null
                        "
                        >PJ /
                        {{ props.rowData.pessoa.pessoaJuridica.razaoSocial }}
                        CNPJ:
                        {{
                          formatCnpjForDisplay(
                            props.rowData.pessoa.pessoaJuridica.cnpjBase,
                            props.rowData.pessoa.pessoaJuridica.cnpjFilial,
                            props.rowData.pessoa.pessoaJuridica.cnpjDigito
                          )
                        }}
                        IE:
                        {{
                          props.rowData.pessoa.pessoaJuridica.inscricaoEstadual
                        }}</span
                      >
                      <span
                        v-if="
                          props.rowData.pessoa !== null &&
                          props.rowData.pessoa.pessoaFisica !== null
                        "
                        >PF / {{ props.rowData.pessoa.pessoaFisica.nome }} -
                        {{ props.rowData.pessoa.pessoaFisica.cpf }}</span
                      >
                      <span
                        v-if="
                          props.rowData.pessoa !== null &&
                          props.rowData.pessoa.pessoaExterior !== null
                        "
                        >PE / {{ props.rowData.pessoa.pessoaExterior.nome }} -
                        {{ props.rowData.pessoa.pessoaExterior.cd }}</span
                      >
                      <span v-if="props.rowData.pessoa == null"
                        >Sem transportadora vinculada</span
                      >
                    </template>
                    <template slot="meioTranspPri" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.cargaMeioTransp !== null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista !==
                            null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista !==
                            null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista
                            .veiculo !== null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista.veiculo
                            .paramTipoRodado !== null
                        "
                        >{{
                          props.rowData.cargaMeioTransp.veiculoMotorista.veiculo
                            .paramTipoRodado.descr
                        }}
                        -
                        {{
                          formatNumber(
                            props.rowData.cargaMeioTransp.veiculoMotorista
                              .veiculo.paramTipoRodado.capacidadePeso
                          )
                        }}
                        KG
                      </span>
                    </template>
                    <!--
                      TMS-8181: a nota bipada que não recebeu vínculo fiscal não
                      entra no "Qtde. Nfs", então a carga sai com menos notas do
                      que foi carregada — sem CT-e e fora do manifesto. Aqui a
                      diferença fica visível antes de expedir.

                      O destaque sai de `qtdNfsSemVinculo`, que o backend
                      calcula por diferença de conjuntos. NÃO compare os dois
                      contadores: uma linha de `carga_doc` sem bip compensa uma
                      órfã, os números batem e a carga errada passa sem alerta.
                    -->
                    <template slot="qtdNfsBipadas" slot-scope="props">
                      <span
                        v-if="temNotaBipadaSemVinculo(props.rowData)"
                        class="badge badge-danger"
                        v-b-tooltip.hover
                        :title="tituloNotaBipadaSemVinculo(props.rowData)"
                        :aria-label="tituloNotaBipadaSemVinculo(props.rowData)"
                        >{{ formatNumber(props.rowData.qtdNfsBipadas) }} ⚠</span
                      >
                      <span v-else-if="props.rowData.qtdNfsBipadas != null">{{
                        formatNumber(props.rowData.qtdNfsBipadas)
                      }}</span>
                      <span v-else class="text-muted">—</span>
                    </template>
                    <template slot="unidade" slot-scope="props">
                      <span v-if="props.rowData.cargaUnidade !== null">{{
                        props.rowData.cargaUnidade.unidade
                      }}</span>
                    </template>
                    <template slot="dtExpedicao" slot-scope="props">
                      <span v-if="props.rowData.dtExpedicao !== null">{{
                        formatDateSeconds(props.rowData.dtExpedicao)
                      }}</span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 3"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="statusProcessoExpedicao" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.statusProcessoExpedicao.valor == 3"
                        >{{ props.rowData.statusProcessoExpedicao.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.statusProcessoExpedicao.valor == 2"
                        >{{ props.rowData.statusProcessoExpedicao.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.statusProcessoExpedicao.valor == 1"
                        >{{ props.rowData.statusProcessoExpedicao.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <ExpedicaoRowActions
                        :row-data="props.rowData"
                        :permite-gerar-doc="permiteGerarDoc"
                        :permite-gerar-despesa="permiteGerarDespesa"
                        :watcher-alert-shipment-ids="watcherAlertShipmentIds"
                        @edit="onEdit"
                        @create-scan="onCreate($event, 2)"
                        @checagem-cte="onCreateChecagemCte"
                        @checagem-nfs="onCreateChecagemNfs"
                        @store="onStoreFromRow"
                        @cancel-montagem="onCancelaMontagemCarga"
                        @imprimir-romaneio="onImprimirRomaneio"
                        @imprimir-provisorio="onImprimirRomaneioProvisorio"
                        @imprimir-manifesto="onImprimirManifesto"
                        @sequencia="sequenciaExpedicao"
                        @gerar-doc="onGerarDoc"
                        @compra-pedagio="onCompraPedagioAvulso"
                        @integracao="onIntegracaoFromRow"
                        @cancel-nstech="onCancelarCargaNstech"
                        @estorna-calculo="onEstornaCalculo"
                        @gera-ciot="onGeraCiot"
                        @cancel-expedicao="onCancelaExpedicao"
                        @detail="onDetailFromRow"
                        @reenviar-itrack="onReenviarItrack"
                        @validate-cte="onValidateDefaultCte"
                        @reenviar-mdfe="onReenviarItrackMdfe"
                        @reenvio-trn="onReenvioTrnDocFis"
                        @desagrupa="onDesagrupaCarga"
                        @envia-frete-avulso="onEnviaFreteAvulso"
                      />
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                          v-if="filterApplied"
                          ref="paginationInfo"
                          :css="css.pagination"
                          info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                          v-if="filterApplied"
                          ref="pagination"
                          :css="css.pagination"
                          @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ExpedicaoForm ref="expedicaoform" />
      <MontagemCargaForm ref="montagemcargaform" />
      <ChecagemCteCarga ref="checagemctecarga" />
      <ChecagemNfsCarga ref="checagemnfscarga" />
      <ExpedicaoCargaForm ref="expedicaocargaform" />
      <ExpedicaoSequenciaForm ref="expedicaosequenciaform" />
      <ExpedicaoModalPagamentoTarget ref="expedicaomodalpagamentotarget" />
      <ExpedicaoModalCiot ref="expedicaomodalciot" :onSuccessCallback="onReloadVuetable" />
      <ExpedicaoFreteAvulso ref="expedicaofreteavulso" />
      <b-modal
        ref="watcherCancelModal"
        centered
        hide-footer
      >
        <template #modal-title>
          <span class="watcher-modal-title">
            <i class="fa fa-exclamation-triangle watcher-modal-title-icon" aria-hidden="true"></i>
            Detectado Nota Fiscal Cancelada
          </span>
        </template>
        <div class="watcher-modal-content">
          <table class="table table-sm table-bordered watcher-modal-table">
            <thead>
              <tr>
                <th>Número da Carga</th>
                <th>Número da Nota</th>
                <th>Chave</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in watcherModalRows" :key="`watcher-modal-row-${index}`">
                <td>{{ item.carga_numero }}</td>
                <td>{{ item.num_fiscal }}</td>
                <td class="watcher-modal-key">{{ item.chave }}</td>
              </tr>
            </tbody>
          </table>

          <p class="mb-2">
            Para remover a nota, é necessário voltar a carga para Montagem de Carga.
          </p>
          <p class="mb-3">
            Se você já realizou o Carregamento Despesa (cálculo), estorne o cálculo e cancele a expedição.
            Depois disso, remova a nota cancelada e refaça o processo de expedição.
          </p>

          <div class="watcher-modal-actions">
            <button
              v-if="watcherModalShowForceCancelNstechButton"
              type="button"
              class="btn btn-danger"
              :disabled="watcherForceCancelNstechLoading"
              @click="onWatcherForceCancelNstech"
            >
              {{
                watcherForceCancelNstechLoading
                  ? "Enviando..."
                  : "Cancelar Carga na NSTech"
              }}
            </button>
            <button
              v-if="watcherModalShowBackButton"
              type="button"
              class="btn btn-warning"
              :disabled="watcherBackToMontagemLoading"
              @click="onWatcherBackToMontagem"
            >
              {{
                watcherBackToMontagemLoading
                  ? "Voltando..."
                  : "Voltar para montagem"
              }}
            </button>
            <button type="button" class="btn btn-secondary" @click="closeWatcherCancellationModal">
              Entendi
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import "./expedicao/registerExpedicaoDetailRow";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import ExpedicaoFilterBar from "./ExpedicaoFilterBar";
import moment from "moment";
import accounting from "accounting";
import ExpedicaoRowActions from "./ExpedicaoRowActions";
import { formatCnpjForDisplay } from "../utils/expedicaoFormatters";
import { expedicaoEndpoints } from "../services/expedicaoEndpoints";
import { createExpedicaoVuetableFields } from "./expedicao/expedicaoVuetableFields";

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ExpedicaoRowActions,
    ExpedicaoForm: () =>
      import(/* webpackChunkName: "expedicao-modals" */ "./ExpedicaoForm"),
    MontagemCargaForm: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./MontagemCargaForm"
      ),
    ExpedicaoCargaForm: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./ExpedicaoCargaForm"
      ),
    ChecagemCteCarga: () =>
      import(/* webpackChunkName: "expedicao-modals" */ "./ChecagemCteCarga"),
    ChecagemNfsCarga: () =>
      import(/* webpackChunkName: "expedicao-modals" */ "./ChecagemNfsCarga"),
    ExpedicaoSequenciaForm: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./ExpedicaoSequenciaForm"
      ),
    ExpedicaoModalPagamentoTarget: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./ExpedicaoModalPagamentoTarget"
      ),
    ExpedicaoModalCiot: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./ExpedicaoModalCiot"
      ),
    ExpedicaoFreteAvulso: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./ExpedicaoFreteAvulso"
      ),
    "vuetable-filterbar": ExpedicaoFilterBar,
  },
  data() {
    return {
      expedicaoApiUrl: expedicaoEndpoints.list,
      filterApplied: false,
      tableKey: 0,
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      peso_bruto: "",
      checkbox: [],
      permiteGerarDoc: true,
      permiteGerarDespesa: true,
      loading: false,
      isDisabled: false,
      loadingData: false,
      loadingDataExpedir: false,
      showModal: false,
      optionsMeioTransp: [],
      optionsStatusProcessoExpedicao: [],
      optionsTipoCarga: [],
      optionsUnidade: [],
      optionsTipoNf: [],
      optionsMunicipio: [],
      optionsPessoaParceira: [],
      optionsRegiao: [],
      optionsTpRodado: [],
      optionsVeiculo: [],
      optionsUf: [],
      dados: {},
      form: new Form({
        carga_id: "",
        pesmot_id: "",
        vlr_total_nfs: 0,
        ignora_nfs_canceladas: "",
        vlr_total_peso_liquido: 0,
        vlr_total_peso_bruto: 0,
        vlr_total_volume: 0,
      }),
      formreenviaritrack: new Form({
        carga_id: "",
        manifesto_id: "",
      }),
      helpForm: new Form({
        tp_pagamento: "",
        tp_tag: "",
        recordCollection: [],
        carga_id: "",
        manifesto_id: [],
        tipo: "",
        status: "",
        tp_agrupamento: "",
        cargaCollection: [],
      }),
      watcherForm: new Form({}),
      watcherPollingTimer: null,
      watcherTrackedShipmentIds: [],
      watcherStatusByShipmentId: {},
      watcherShipmentNumberById: {},
      watcherEvents: [],
      watcherNotifiedEventIds: [],
      watcherModalEvents: [],
      watcherBackToMontagemLoading: false,
      watcherForceCancelNstechLoading: false,
      watcherFloatingPosition: {
        left: 0,
        top: 88,
      },
      watcherDragOffset: {
        x: 0,
        y: 0,
      },
      watcherDragging: false,
      watcherMovedDuringDrag: false,
      fields: createExpedicaoVuetableFields(),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this._expedicaoFilterResetHandler = () => this.onFilterReset();
    this._expedicaoFilterSetHandler = (eventData) =>
      this.onFilterSet(eventData);
    this.$events.$on("filter-reset", this._expedicaoFilterResetHandler);
    this.$events.$on("filter-set", this._expedicaoFilterSetHandler);
    const cached = this.$store.state.expedicaoLivGeral;
    if (cached) {
      this._populateLivSimple(cached);
    } else {
      this.getLivSimple();
    }

    this.setWatcherInitialPosition();
    this.ensureWatcherFloatingPosition();
    window.addEventListener("mousemove", this.onWatcherDrag);
    window.addEventListener("mouseup", this.stopWatcherDrag);
    window.addEventListener("touchmove", this.onWatcherDrag, { passive: false });
    window.addEventListener("touchend", this.stopWatcherDrag);
  },
  beforeDestroy() {
    if (this._expedicaoFilterResetHandler) {
      this.$events.$off("filter-reset", this._expedicaoFilterResetHandler);
    }
    if (this._expedicaoFilterSetHandler) {
      this.$events.$off("filter-set", this._expedicaoFilterSetHandler);
    }

    this.stopWatcherPolling();
    window.removeEventListener("mousemove", this.onWatcherDrag);
    window.removeEventListener("mouseup", this.stopWatcherDrag);
    window.removeEventListener("touchmove", this.onWatcherDrag);
    window.removeEventListener("touchend", this.stopWatcherDrag);
  },
  methods: {
    /*
     * TMS-8181: quantas notas desta carga foram bipadas e NÃO têm vínculo
     * fiscal ativo. O número vem pronto do backend, por diferença de conjuntos
     * (`ShipmentConsistencyService::divergentInvoices`).
     *
     * NÃO derive isto de `qtdNfsBipadas - qtdNfs`. Contagem não revela
     * diferença de conjuntos: uma linha de `carga_doc` sem bip — nota entrada
     * por seleção, ou linha inativa — compensa uma órfã, os dois contadores
     * empatam e a carga que mais precisa do alerta é a única que não o recebe.
     */
    notasBipadasSemVinculo(rowData) {
      // `|| 0` e nao `?? 0`: o Babel desta build nao suporta nullish
      // coalescing e o `npm run build-staging` quebra. Dentro de `Number()`
      // os dois sao equivalentes aqui — so divergiriam em 0, "" e false, e
      // `Number(x || 0) === Number(x ?? 0)` para os tres.
      return Number(rowData.qtdNfsSemVinculo || 0);
    },
    temNotaBipadaSemVinculo(rowData) {
      return this.notasBipadasSemVinculo(rowData) > 0;
    },
    /*
     * A tela lista carga Finalizada e carga Expedida, e a saída é diferente nos
     * dois casos — mas as DUAS têm saída pela própria tela. Alerta vermelho sem
     * saída é o que a TMS-7223 mediu como origem de chamado.
     *
     * - Finalizada: "Cancelar montagem" (`montagemcarga.cancelar`, devolve a
     *   carga ao status Pendente) e refaz o fechamento.
     * - Expedida: "Cancelar processo de Expedição" (`expedicao.cancelar`), que
     *   devolve a carga a Finalizada com `status_processo_expedicao` Pendente —
     *   daí ela segue pelo caminho acima.
     *
     * NÃO mande abrir chamado na carga expedida. A operação cancela a expedição
     * sozinha, e `ExpedicaoController@cancelaExpedicao` não bloqueia por CT-e
     * autorizado. O gate que ela esbarra primeiro é o manifesto — "A carga
     * precisa estar com todos os Manifestos cancelados para realizar o
     * cancelamento da Expedição" —, por isso ele é nomeado na mensagem: mandar
     * cancelar a expedição sem avisar do MDF-e entrega o operador a uma recusa.
     */
    tituloNotaBipadaSemVinculo(rowData) {
      const orfas = this.notasBipadasSemVinculo(rowData);
      const plural = orfas > 1;

      const diagnostico = plural
        ? `${orfas} notas bipadas sem vínculo fiscal — não sairão no CT-e nem no manifesto.`
        : `${orfas} nota bipada sem vínculo fiscal — não sairá no CT-e nem no manifesto.`;

      const saida = this.cargaJaExpedida(rowData)
        ? "Cancele o processo de expedição — os manifestos precisam estar cancelados antes — e refaça o fechamento."
        : "Cancele a montagem da carga e refaça o fechamento antes de expedir.";

      return `${diagnostico} ${saida}`;
    },
    cargaJaExpedida(rowData) {
      // `status` chega como objeto { descr, valor } no payload da listagem.
      // 3 = Expedida; 6 = Finalizada.
      const status = rowData.status || {};

      return Number(status.valor || 0) === 3;
    },
    dispatchReturnApi(...args) {
      return new ReturnApi(...args);
    },
    formatCnpjForDisplay,
    onStoreFromRow(payload) {
      this.onStore(payload.cargaId, payload.cargaMeioTransp, payload.numCarga);
    },
    onIntegracaoFromRow({ rowData, tipo }) {
      this.onEventoIntegracao(rowData, tipo);
    },
    onDetailFromRow(data) {
      this.onDetail(data, null, null);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onReenviarItrack(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formreenviaritrack.carga_id = carga_id;
      this.formreenviaritrack
        .post(expedicaoEndpoints.reenviaritrack)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, null, null, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
        });
    },
    onValidateDefaultCte(shipmentId) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = shipmentId;
      this.helpForm
        .post(expedicaoEndpoints.gerarDocumentos(shipmentId))
        .then((response) => {
          this.dispatchReturnApi(response, this, true, null, null, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
        });
    },
    onReenvioTrnDocFis(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = carga_id;
      this.helpForm
        .post(expedicaoEndpoints.reenviotrndocfis)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, null, null, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
        });
    },
    onReenviarItrackMdfe(manifesto_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formreenviaritrack.manifesto_id = manifesto_id;
      this.formreenviaritrack
        .post(expedicaoEndpoints.reenviaritrackmdfe)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, null, null, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
        });
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onFilterSet(data_filter) {
      this.filterApplied = true;
      this.loadingData = true;

      this.moreParams = {
        observacao: data_filter.observacao,
        dt_emi_ini: data_filter.dt_emi_ini,
        regiao: data_filter.regiao,
        redespacho: data_filter.redespacho,
        dt_emi_fim: data_filter.dt_emi_fim,
        num_carga: data_filter.num_carga,
        consulta_completa: data_filter.consulta_completa,
        unidade: data_filter.unidade.value,
        status_processo_expedicao: data_filter.status_processo_expedicao.value,
        transportadora: data_filter.transportadora.pessoa_id,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.filterApplied = true;
      this.loadingData = true;
      this.moreParams = {};
      this.watcherTrackedShipmentIds = [];
      this.watcherStatusByShipmentId = {};
      this.watcherShipmentNumberById = {};
      this.watcherEvents = [];
      this.watcherNotifiedEventIds = [];
      this.watcherModalEvents = [];
      this.stopWatcherPolling();

      Vue.nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.selectedTo = [];
          this.$refs.vuetable.resetData();
        }
        if (this.$refs.pagination) {
          this.$refs.pagination.resetData();
        }
      });
      this.loadingData = false;
    },
    onLoaded() {
      this.loadingData = false;
      this.syncWatcherTracking();
    },
    getWatcherFloatingSize() {
      return {
        width: 320,
        height: 72,
      };
    },
    setWatcherInitialPosition() {
      const { width } = this.getWatcherFloatingSize();
      this.watcherFloatingPosition.left = Math.max(window.innerWidth - width - 24, 8);
      this.watcherFloatingPosition.top = 88;
    },
    ensureWatcherFloatingPosition() {
      const { width, height } = this.getWatcherFloatingSize();
      const maxLeft = Math.max(window.innerWidth - width, 8);
      const maxTop = Math.max(window.innerHeight - height, 8);
      this.watcherFloatingPosition.left = Math.min(
        Math.max(this.watcherFloatingPosition.left, 8),
        maxLeft
      );
      this.watcherFloatingPosition.top = Math.min(
        Math.max(this.watcherFloatingPosition.top, 8),
        maxTop
      );
    },
    getWatcherPointer(event) {
      if (event.touches && event.touches.length > 0) {
        return {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
        };
      }

      if (event.changedTouches && event.changedTouches.length > 0) {
        return {
          x: event.changedTouches[0].clientX,
          y: event.changedTouches[0].clientY,
        };
      }

      if (typeof event.clientX === "number" && typeof event.clientY === "number") {
        return {
          x: event.clientX,
          y: event.clientY,
        };
      }

      return null;
    },
    startWatcherDrag(event) {
      const pointer = this.getWatcherPointer(event);
      if (!pointer) {
        return;
      }

      this.ensureWatcherFloatingPosition();
      this.watcherDragging = true;
      this.watcherMovedDuringDrag = false;
      this.watcherDragOffset = {
        x: pointer.x - this.watcherFloatingPosition.left,
        y: pointer.y - this.watcherFloatingPosition.top,
      };
    },
    onWatcherDrag(event) {
      if (!this.watcherDragging) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }

      const pointer = this.getWatcherPointer(event);
      if (!pointer) {
        return;
      }

      const { width: floatingTabWidth, height: floatingTabHeight } = this.getWatcherFloatingSize();
      const nextLeft = pointer.x - this.watcherDragOffset.x;
      const nextTop = pointer.y - this.watcherDragOffset.y;
      const maxLeft = Math.max(window.innerWidth - floatingTabWidth, 8);
      const maxTop = Math.max(window.innerHeight - floatingTabHeight, 8);

      this.watcherFloatingPosition.left = Math.min(Math.max(nextLeft, 8), maxLeft);
      this.watcherFloatingPosition.top = Math.min(Math.max(nextTop, 8), maxTop);
      this.watcherMovedDuringDrag = true;
    },
    stopWatcherDrag() {
      this.watcherDragging = false;
    },
    onWatcherTabClick() {
      if (this.watcherMovedDuringDrag) {
        this.watcherMovedDuringDrag = false;
        return;
      }

      this.openWatcherPendingEvents();
    },
    syncWatcherTracking() {
      const rows = this.$refs.vuetable && Array.isArray(this.$refs.vuetable.tableData)
        ? this.$refs.vuetable.tableData
        : [];

      if (!rows.length) {
        this.watcherTrackedShipmentIds = [];
        this.watcherStatusByShipmentId = {};
        this.watcherShipmentNumberById = {};
        this.watcherEvents = [];
        this.watcherNotifiedEventIds = [];
        this.watcherModalEvents = [];
        this.stopWatcherPolling();
        return;
      }

      const nextShipmentIds = Array.from(new Set(
        rows
          .map((row) => Number(row && row.cargaId))
          .filter((shipmentId) => Number.isInteger(shipmentId) && shipmentId > 0)
      ));
      if (!nextShipmentIds.length) {
        return;
      }

      const nextShipmentNumberById = rows.reduce((acc, row) => {
        const shipmentId = Number(row && row.cargaId);
        if (!Number.isInteger(shipmentId) || shipmentId <= 0) {
          return acc;
        }

        acc[shipmentId] = row && row.numCarga != null
          ? String(row.numCarga)
          : String(shipmentId);

        return acc;
      }, {});

      const hasTrackedShipmentsChanged =
        nextShipmentIds.length !== this.watcherTrackedShipmentIds.length ||
        nextShipmentIds.some((shipmentId, index) => shipmentId !== this.watcherTrackedShipmentIds[index]);

      if (hasTrackedShipmentsChanged) {
        this.watcherTrackedShipmentIds = nextShipmentIds;
        this.watcherStatusByShipmentId = {};
        this.watcherEvents = [];
        this.watcherNotifiedEventIds = [];
        this.watcherModalEvents = [];
      }
      this.watcherShipmentNumberById = nextShipmentNumberById;

      this.loadWatcherStatusAndEventsForAll();
      this.startWatcherPolling();
    },
    startWatcherPolling() {
      this.stopWatcherPolling();
      this.watcherPollingTimer = setInterval(() => {
        this.loadWatcherStatusAndEventsForAll();
      }, 15000);
    },
    stopWatcherPolling() {
      if (this.watcherPollingTimer) {
        clearInterval(this.watcherPollingTimer);
        this.watcherPollingTimer = null;
      }
    },
    async loadWatcherStatus(shipmentId) {
      try {
        const statusResponse = await this.watcherForm.get(
          `/api/watcher/carga/${shipmentId}/status`
        );
        const statusData = statusResponse && statusResponse.data;
        return statusData || null;
      } catch (error) {
        return null;
      }
    },
    async loadWatcherEvents(shipmentId) {
      try {
        const eventsResponse = await this.watcherForm.get(
          `/api/watcher/carga/${shipmentId}/eventos?nao_lidos=1`
        );
        const eventsData = eventsResponse && eventsResponse.data;

        return Array.isArray(eventsData) ? eventsData : [];
      } catch (error) {
        return [];
      }
    },
    async loadWatcherStatusAndEventsForAll() {
      if (!Array.isArray(this.watcherTrackedShipmentIds) || !this.watcherTrackedShipmentIds.length) {
        return;
      }

      try {
        const statusPairs = await Promise.all(
          this.watcherTrackedShipmentIds.map(async (shipmentId) => [
            shipmentId,
            await this.loadWatcherStatus(shipmentId),
          ])
        );

        this.watcherStatusByShipmentId = statusPairs.reduce((acc, [shipmentId, status]) => {
          if (status) {
            acc[shipmentId] = status;
          }
          return acc;
        }, {});

        const shipmentsWithPendingEvents = this.watcherTrackedShipmentIds.filter((shipmentId) => {
          const status = this.watcherStatusByShipmentId[shipmentId];
          return status && status.has_pending_events;
        });

        if (!shipmentsWithPendingEvents.length) {
          this.watcherEvents = [];
          return;
        }

        const eventGroups = await Promise.all(
          shipmentsWithPendingEvents.map((shipmentId) => this.loadWatcherEvents(shipmentId))
        );

        this.watcherEvents = eventGroups
          .flat()
          .sort((a, b) => {
            const dateA = a && a.dt_detected ? new Date(a.dt_detected).getTime() : 0;
            const dateB = b && b.dt_detected ? new Date(b.dt_detected).getTime() : 0;
            return dateB - dateA;
          });
        this.notifyFirstUnreadWatcherEvent();
      } catch (error) {
        // Falhas pontuais do watcher não devem interromper a tela de expedição.
      }
    },
    notifyFirstUnreadWatcherEvent() {
      const firstUnread = this.watcherEvents.find(
        (event) => !this.watcherNotifiedEventIds.includes(event.watchevt_id)
      );

      if (!firstUnread) {
        return;
      }

      this.markWatcherEventsAsNotified(this.watcherEvents);
      this.openWatcherCancellationModal(this.watcherEvents);
    },
    async ackWatcherEvent(eventId, shipmentId) {
      if (!shipmentId) {
        return;
      }

      try {
        await this.watcherForm.post(
          `/api/watcher/carga/${shipmentId}/ack-evento/${eventId}`
        );
        this.loadWatcherStatusAndEventsForAll();
      } catch (error) {
        // Falha de ACK não deve quebrar o fluxo da tela.
      }
    },
    openWatcherPendingEvents() {
      if (!this.watcherEvents.length) {
        this.$Simplert.open({
          title: "Watcher",
          message: "Nenhum evento pendente no momento.",
          type: "info",
        });
        return;
      }

      this.openWatcherCancellationModal(this.watcherEvents);
    },
    markWatcherEventsAsNotified(events) {
      if (!Array.isArray(events) || !events.length) {
        return;
      }

      const ids = events
        .map((event) => event && event.watchevt_id)
        .filter((eventId) => typeof eventId === "number");

      this.watcherNotifiedEventIds = Array.from(new Set([
        ...this.watcherNotifiedEventIds,
        ...ids,
      ]));
    },
    openWatcherCancellationModal(events) {
      this.watcherModalEvents = Array.isArray(events) ? events : [];

      if (!this.$refs.watcherCancelModal) {
        return;
      }

      this.$refs.watcherCancelModal.show();
    },
    closeWatcherCancellationModal() {
      if (!this.$refs.watcherCancelModal) {
        return;
      }

      this.$refs.watcherCancelModal.hide();
    },
    async onWatcherBackToMontagem() {
      const shipment = this.getWatcherModalTargetShipment();
      if (!shipment) {
        this.$Simplert.open({
          title: "Watcher",
          message: "Não foi possível localizar a carga para retornar à montagem.",
          type: "warning",
        });
        return;
      }

      const shipmentId = Number(shipment.cargaId);
      if (!Number.isInteger(shipmentId) || shipmentId <= 0) {
        this.$Simplert.open({
          title: "Watcher",
          message: "Identificador da carga inválido para retorno à montagem.",
          type: "warning",
        });
        return;
      }

      this.watcherBackToMontagemLoading = true;
      this.closeWatcherCancellationModal();
      this.helpForm.carga_id = shipmentId;
      const shipmentProcessStatus = Number(
        shipment &&
          shipment.statusProcessoExpedicao &&
          shipment.statusProcessoExpedicao.valor
      );
      const isPendingShipment = shipmentProcessStatus === 1;
      const isInProgressShipment = shipmentProcessStatus === 2;

      if (!isPendingShipment && !isInProgressShipment) {
        this.watcherBackToMontagemLoading = false;
        this.$Simplert.open({
          title: "Watcher",
          message:
            "A ação de voltar para montagem só está disponível para cargas Pendente ou Em Andamento.",
          type: "warning",
        });
        return;
      }

      if (isInProgressShipment) {
        try {
          await this.helpForm.post(expedicaoEndpoints.cancelar);
        } catch (error_) {
          this.dispatchReturnApi(error_, this, true, false, false, false);
          this.watcherBackToMontagemLoading = false;
          return;
        }
      }

      try {
        await this.helpForm.patch(expedicaoEndpoints.montagemCargaCancelar);
        this.$Simplert.open({
          title: "Sucesso!",
          message: isInProgressShipment
            ? "Carga retornada para Montagem com sucesso. Expedição e montagem foram canceladas."
            : "Carga pendente retornada para Montagem com sucesso.",
          type: "success",
        });
      } catch (error_) {
        this.dispatchReturnApi(error_, this);
      } finally {
        this.watcherBackToMontagemLoading = false;
        this.onFilterReset();
      }
    },
    async onWatcherForceCancelNstech() {
      const shipment = this.getWatcherModalTargetShipment();
      const shipmentId = Number(shipment && shipment.cargaId);
      if (!Number.isInteger(shipmentId) || shipmentId <= 0) {
        this.$Simplert.open({
          title: "Watcher",
          message: "Não foi possível identificar a carga para solicitar cancelamento na NSTech.",
          type: "warning",
        });
        return;
      }

      this.watcherForceCancelNstechLoading = true;
      this.closeWatcherCancellationModal();
      try {
        const response = await this.helpForm.delete(
          expedicaoEndpoints.cancelarNstech(shipmentId)
        );
        this.dispatchReturnApi(response, this, true, false, false, false);
      } catch (error_) {
        this.dispatchReturnApi(error_, this, true, false, false, false);
      } finally {
        this.watcherForceCancelNstechLoading = false;
        this.onReloadVuetable();
        this.loadWatcherStatusAndEventsForAll();
      }
    },
    getWatcherModalTargetShipment() {
      if (!Number.isInteger(this.watcherModalTargetShipmentId)) {
        return null;
      }

      const rows =
        this.$refs.vuetable && Array.isArray(this.$refs.vuetable.tableData)
          ? this.$refs.vuetable.tableData
          : [];

      return (
        rows.find(
          (row) =>
            Number(row && row.cargaId) === this.watcherModalTargetShipmentId
        ) || null
      );
    },
    onEdit(data) {
      this.$refs.expedicaoform.onEdit(data);
    },
    onCreate(carga_id, tipo) {
      this.$refs.expedicaocargaform.onCreate(carga_id, tipo);
    },
    onStore(carga_id, cargaMeioTransp, num_carga) {
      let motorista = "";
      let pesmot_id = "";

      if (
        cargaMeioTransp != null &&
        cargaMeioTransp.veiculoMotorista != null &&
        cargaMeioTransp.veiculoMotorista.pessoaMotorista != null &&
        cargaMeioTransp.veiculoMotorista.pessoaMotorista.pessoaFisica != null
      ) {
        motorista =
          cargaMeioTransp.veiculoMotorista.pessoaMotorista.pessoaFisica.nome;
        pesmot_id =
          cargaMeioTransp.veiculoMotorista.pessoaMotorista.pesmotId;
      }

      const mensagem =
        motorista === ""
          ? "Você deseja confirmar a expedição para a carga " +
            num_carga +
            "? Não há motorista vinculado."
          : "Você deseja confirmar a expedição para o motorista " +
            motorista +
            " na carga " +
            num_carga +
            "?";

      const appendErrorsToVm = (vm, errPayload) => {
        vm.errors_array = [];
        Object.keys(errPayload).forEach((property) => {
          if (typeof errPayload[property] === "object") {
            errPayload[property].forEach((obj) => {
              vm.errors_array.push({
                erro: obj,
              });
            });
          }
        });
      };

      const confirmAcaoNfsCanceladas = () => {
        this.loading = true;
        this.isDisabled = true;
        this.form.carga_id = carga_id;
        this.form.ignora_nfs_canceladas = 1;
        this.form.pesmot_id = pesmot_id;
        this.form
          .post(expedicaoEndpoints.store)
          .then((response) => {
            this.dispatchReturnApi(response, this);
            this.$parent.onFilterReset();
          })
          .catch((error_) => {
            this.dispatchReturnApi(error_, this, true, null, null, false);
            appendErrorsToVm(this, error_);
          });
      };

      const confirmAcao = () => {
        this.loading = true;
        this.isDisabled = true;
        this.form.carga_id = carga_id;
        this.form.ignora_nfs_canceladas = 2;
        this.form.pesmot_id = pesmot_id;
        this.form
          .post(expedicaoEndpoints.store)
          .then((response) => {
            this.dispatchReturnApi(response, this);
            this.$parent.onFilterReset();
          })
          .catch((error_) => {
            if (error_.has_nfs_canceladas) {
              this.loading = false;
              this.isDisabled = false;
              const obj2 = {
                title:
                  "Você deseja confirmar a expedição com notas canceladas?",
                message: error_.message,
                customConfirmBtnText: "Sim",
                customCloseBtnText: "Não",
                type: "warning",
                useConfirmBtn: true,
                onConfirm: confirmAcaoNfsCanceladas,
              };

              this.$Simplert.open(obj2);
            } else {
              this.dispatchReturnApi(error_, this, true, null, null, false);
              appendErrorsToVm(this, error_);
            }
          });
      };

      const obj = {
        title: "Confirmar Expedição ?",
        message: mensagem,
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: confirmAcao,
      };

      this.$Simplert.open(obj);
    },
    onCreateChecagemCte(cargaId) {
      this.$refs.checagemctecarga.onCreate(cargaId);
    },
    onCreateChecagemNfs(cargaId) {
      this.$refs.checagemnfscarga.onCreate(cargaId);
    },
    onImprimirRomaneio(data) {
      this.isDisabled = true;
      this.loadingData = true;
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
        .post(expedicaoEndpoints.romaneioImprimir)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false, false);
          this.loadingData = false;
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
          this.loadingData = false;
        });
    },
    onImprimirRomaneioProvisorio(data) {
      this.isDisabled = true;
      this.loadingData = true;
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
        .post(expedicaoEndpoints.romaneioProvisorioImprimir)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false, false);
          this.loadingData = false;
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
          this.loadingData = false;
        });
    },
    onImprimirManifesto(manifestoIds) {
      if (!Array.isArray(manifestoIds) || !manifestoIds.length) {
        return;
      }
      this.helpForm.manifesto_id = manifestoIds;
      this.helpForm
        .post(expedicaoEndpoints.mdfeImprimir)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this);
        });
    },
    onCancelaMontagemCarga(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = carga_id;
      this.helpForm
        .patch(expedicaoEndpoints.montagemCargaCancelar)
        .then((response) => {
          this.dispatchReturnApi(response, this);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this);
        });
    },
    getLivSimple() {
      this.helpForm
        .get("/api/expedicao/jsonlistsimple")
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false);
          this._populateLivSimple(response);
        })
        .catch((error_) => {
          console.log("Erro aqui", error_);
          this.dispatchReturnApi(error_, this);
        });
    },
    _populateLivSimple(response) {
      this.optionsMeioTransp = [];
      this.optionsVeiculo = [];
      this.optionsTpRodado = [];
      this.optionsPessoaParceira = [];
      this.optionsRegiao = [];
      this.optionsUnidade = [];
      this.optionsStatusProcessoExpedicao = [];
      response.tp_rodado.forEach((obj) => {
        this.optionsTpRodado.push({
          label: obj.descr,
          value: obj.partiprod_id,
          tp_rodado: obj.tp_rodado,
        });
      });
      response.pessoa_parceira.forEach((obj) => {
        this.optionsPessoaParceira.push({
          label: obj.descr,
          value: obj.pespar_id,
        });
      });
      response.regiao.forEach((obj) => {
        this.optionsRegiao.push({
          label: obj.cd + ' - ' + obj.descr,
          value: obj.regiao_id,
        });
      });
      response.unidade.forEach((obj) => {
        this.optionsUnidade.push({
          label: obj.descr,
          value: obj.unidade_id,
        });
      });
      response.status_processo_expedicao.forEach((obj) => {
        this.optionsStatusProcessoExpedicao.push({
          label: obj.descr,
          value: obj.valor,
        });
      });
    },
    onAgrupa() {
      this.helpForm.cargaCollection = [];
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.helpForm.cargaCollection.push(obj);
      });
      this.helpForm.tp_agrupamento = 1;
      this.helpForm
        .post(expedicaoEndpoints.agrupar)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, null, null, false);
        })
        .catch((error_) => {
          if (error_.tp_message === "error") {
            this.dispatchReturnApi(error_, this, false, false, false, false);
          } else if (error_.tp_message === "success") {
            this.dispatchReturnApi(error_, this, false, false, true, false);
          } else {
            const message = error_.message;

            const confirmDesassociarFn = () => {
              this.loading = true;
              this.helpForm.tp_agrupamento = 2;
              this.helpForm
                .post(expedicaoEndpoints.agrupar)
                .then((response) => {
                  this.dispatchReturnApi(
                    response,
                    this,
                    true,
                    false,
                    true,
                    false
                  );
                })
                .catch((agruparErr) => {
                  this.dispatchReturnApi(agruparErr, this);
                });
            };

            const obj = {
              title: "Atenção!",
              message,
              customConfirmBtnText: "Sim",
              customCloseBtnText: "Não",
              type: "info",
              useConfirmBtn: true,
              onConfirm: confirmDesassociarFn,
            };

            this.$Simplert.open(obj);
          }
        });
    },
    onDesagrupaCarga(data) {
      this.helpForm.carga_id = data;
      this.helpForm
          .post(expedicaoEndpoints.desagrupar)
          .then((response) => {
            this.dispatchReturnApi(response, this, true, false, true, false);
          })
          .catch((error_) => {
            this.dispatchReturnApi(error_, this, true, null, null, false);
          });
    },
    onGerarDoc(data) {
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
        .post(expedicaoEndpoints.mdferomaneio)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false);
          this.permiteGerarDoc = false;
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
          this.permiteGerarDoc = false;
        });
    },
    onEstornaCalculo(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = carga_id;
      this.form
        .post(expedicaoEndpoints.calculoEstornar)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false, false);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, false, false, false);
        });
    },
    onCancelarCargaNstech(rowData) {
      if (rowData.statusProcessoExpedicao.valor != 3) {
        this.$Simplert.open({
          title: "Atenção",
          message: "Processo de expedição em andamento, por favor aguarde para cancelar.",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      this.isDisabled = true;
      this.helpForm
        .delete(expedicaoEndpoints.cancelarNstech(rowData.cargaId))
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, false, false, false);
        });
    },
    onGeraCiot(data) {
      this.$refs.expedicaomodalciot.onCreate(data);
    },
    onCompraPedagioAvulso(data) {
      this.$refs.expedicaomodalpagamentotarget.onCreate(data, "pedagioavulso");
    },
    onEnviaFreteAvulso(data) {
      let avulso = false;
      if (data.pessoa.pessoaTranspCalculo.length > 0) {
        data.pessoa.pessoaTranspCalculo.forEach((obj) => {
          if (obj.tpCalc === 8 && data.tpOperacaoPrincipal == obj.tpOperacao && obj.status == 1) {
            avulso = true;
          }
        });
      }
      if (avulso === true) {
        this.$refs.expedicaofreteavulso.onCreate(data);
      } else {
        this.onEventoIntegracao(data, 4);
      }
    },
    onCancelaExpedicao(data) {
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
          .post(expedicaoEndpoints.cancelar)
          .then((response) => {
            this.dispatchReturnApi(response, this, true, false, false, false);
            this.onFilterReset();
          })
          .catch((error_) => {
            this.dispatchReturnApi(error_, this, true, false, false, false);
            this.onFilterReset();
          });
    },
    onEventoIntegracao(data, tipo) {
      this.helpForm.carga_id = data.cargaId;
      this.permiteGerarDespesa = false;
      this.helpForm.tipo = tipo;
      this.helpForm
          .post(expedicaoEndpoints.integracaoManual)
          .then((response) => {
            this.dispatchReturnApi(response, this, true, false, false);
            this.permiteGerarDespesa = false;
            this.onFilterReset();
          })
          .catch((error_) => {
            this.dispatchReturnApi(error_, this, true, false, false, false);
            this.permiteGerarDespesa = false;
            this.onFilterReset();
          });
    },
    sequenciaExpedicao(carga_id) {
      this.$refs.expedicaosequenciaform.getData(carga_id);
      this.$refs.expedicaosequenciaform.onView();
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.cargaId);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD MM YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatDateSeconds(value, fmt = "D/MM/YYYY HH:mm:ss") {
      return value == null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
    onError(response) {
      this.dispatchReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    watcherAlertShipmentIds() {
      return Object.entries(this.watcherStatusByShipmentId || {})
        .filter(([, status]) => Boolean(status && status.has_pending_events))
        .map(([shipmentId]) => Number(shipmentId))
        .filter((shipmentId) => Number.isInteger(shipmentId) && shipmentId > 0);
    },
    watcherModalTargetShipmentId() {
      if (!Array.isArray(this.watcherModalEvents) || !this.watcherModalEvents.length) {
        return null;
      }

      const uniqueShipmentIds = Array.from(new Set(
        this.watcherModalEvents
          .map((event) => Number(event && event.carga_id))
          .filter((shipmentId) => Number.isInteger(shipmentId) && shipmentId > 0)
      ));

      if (uniqueShipmentIds.length !== 1) {
        return null;
      }

      return uniqueShipmentIds[0];
    },
    watcherModalTargetIsPending() {
      const shipment = this.getWatcherModalTargetShipment();
      return Boolean(
        shipment &&
          shipment.statusProcessoExpedicao &&
          Number(shipment.statusProcessoExpedicao.valor) === 1
      );
    },
    watcherModalShowBackButton() {
      if (!Number.isInteger(this.watcherModalTargetShipmentId)) {
        return false;
      }

      return this.watcherTrackedShipmentIds.length === 1 || this.watcherModalTargetIsPending;
    },
    watcherModalShowForceCancelNstechButton() {
      if (!Number.isInteger(this.watcherModalTargetShipmentId)) {
        return false;
      }

      const shipment = this.getWatcherModalTargetShipment();
      if (!shipment) {
        return false;
      }

      const shipmentId = Number(shipment.cargaId);
      const hasPendingAlert = this.watcherAlertShipmentIds.includes(shipmentId);
      const hasNstechIntegration =
        Array.isArray(shipment.integracaoNstech) &&
        shipment.integracaoNstech.length > 0;
      const nstechStatus = Number(shipment.statusExpedicaoNstech);
      const isCancelingOrCanceled = [5, 6].includes(nstechStatus);

      return hasPendingAlert && hasNstechIntegration && !isCancelingOrCanceled;
    },
    watcherStatusSummary() {
      const statusList = Object.values(this.watcherStatusByShipmentId || {});
      if (!statusList.length) {
        return {
          watcher_ativo: false,
          has_pending_events: false,
          open_events_count: 0,
        };
      }

      const openEventsCount = statusList.reduce((total, status) => {
        return total + Number(status && status.open_events_count ? status.open_events_count : 0);
      }, 0);

      return {
        watcher_ativo: statusList.some((status) => Boolean(status && status.watcher_ativo)),
        has_pending_events: openEventsCount > 0 || statusList.some((status) => Boolean(status && status.has_pending_events)),
        open_events_count: openEventsCount,
      };
    },
    showFloatingWatcher() {
      return Boolean(
        this.watcherTrackedShipmentIds.length &&
        (this.watcherStatusSummary.watcher_ativo || this.watcherStatusSummary.has_pending_events)
      );
    },
    watcherFloatingStyle() {
      return {
        left: `${this.watcherFloatingPosition.left}px`,
        top: `${this.watcherFloatingPosition.top}px`,
      };
    },
    watcherModalRows() {
      if (!Array.isArray(this.watcherModalEvents) || !this.watcherModalEvents.length) {
        return [{ carga_numero: "N/A", num_fiscal: "N/A", chave: "N/A" }];
      }

      return this.watcherModalEvents.map((event) => ({
        carga_numero: event && event.carga_id && this.watcherShipmentNumberById[event.carga_id]
          ? this.watcherShipmentNumberById[event.carga_id]
          : (event && event.carga_id ? event.carga_id : "N/A"),
        num_fiscal: event && event.payload && event.payload.num_fiscal
          ? event.payload.num_fiscal
          : "N/A",
        chave: event && event.payload && event.payload.chave
          ? event.payload.chave
          : "N/A",
      }));
    },
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>

<style scoped>
.watcher-floating-tab {
  position: fixed;
  z-index: 1200;
  min-width: 250px;
  max-width: 320px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 12px;
  cursor: pointer;
  color: #ffffff;
  background: linear-gradient(135deg, #1f2937, #111827);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
  user-select: none;
  touch-action: none;
}

.watcher-fallback-gif {
  position: relative;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
}

.watcher-detective {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 26px;
  animation: watcher-bob 1.4s ease-in-out infinite;
}

.watcher-lens {
  position: absolute;
  right: 0;
  bottom: -2px;
  font-size: 18px;
  animation: watcher-scan 1.1s ease-in-out infinite;
}

.watcher-floating-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.watcher-floating-text small {
  opacity: 0.9;
}

.watcher-pending-pill {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #dc3545;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.watcher-modal-table th,
.watcher-modal-table td {
  vertical-align: middle;
}

.watcher-modal-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.watcher-modal-title-icon {
  color: #f0ad4e;
}

.watcher-modal-key {
  word-break: break-all;
}

.watcher-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@keyframes watcher-bob {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}

@keyframes watcher-scan {
  0%,
  100% {
    transform: translateX(0) rotate(0deg);
  }
  50% {
    transform: translateX(-2px) rotate(-8deg);
  }
}
</style>
